/** The public configuration the forms need, fetched once per page load. */

import { useEffect, useState } from 'react'
import type { ClientConfigResponse } from '../../shared/api.ts'
import { fetchClientConfig } from './api.ts'

export function useClientConfig(): ClientConfigResponse | null {
  const [config, setConfig] = useState<ClientConfigResponse | null>(null)

  useEffect(() => {
    let cancelled = false
    void fetchClientConfig().then(
      (value) => {
        if (!cancelled) setConfig(value)
      },
      () => {
        // The forms stay usable without it; submission is what fails, and
        // that failure is reported by the server in the user's language.
      },
    )
    return () => {
      cancelled = true
    }
  }, [])

  return config
}
